'use strict'

jQuery(document).ready(function($) {
	/**
	 * Floating menu
	 */

	// Return to top button
	// First, unbind the button (a.k.a. remove all event listeners) that's been
	// set in main JTF since we need to target a different element.
	$('.returntotop__container').unbind();

	// Then target the required button and scroll back to top on click.
	$('.returntotop__link--top').click(function(event) {
		event.preventDefault();
		$('html, body').animate({
			scrollTop: 0
		}, 'fast');
		return false
	});

	// Sharebox open/close
	$('.returntotop__sharebox--trigger').on( "click", function() {
		if ( $('.returntotop__sharebox').hasClass('returntotop__sharebox--open') ) {
			$('.returntotop__sharebox').removeClass('returntotop__sharebox--open');
		} else {
			$('.returntotop__sharebox').addClass('returntotop__sharebox--open');
		}
	});
});
